export const getPrototypeOrValueFromValue = (value) => ({ isPrototype: false, value });
